export default __webpack_public_path__ + "static/media/complementary--both-directions--g1.1eaa27e4.png";